import React from 'react';
import {isMobile, isBrowser} from 'react-device-detect';
import BtnSubmit from '../../../Shared/Buttons/BtnSubmit';
import {selectAccountStickyFooterBusinessIndividual} from './../gaReports';

export default function StickyOrderPackageButton(props) {
  const gaAndGoToSelectAccount = () => {
    selectAccountStickyFooterBusinessIndividual();
    props.changeAccountBusinessIndividual();
  };
  return (
    <div className='abroad-sticky-order-button'>
      <BtnSubmit text={`לרכישת חבילות חו”ל למנוי`} onclick={() => gaAndGoToSelectAccount()} />
    </div>
  );
}
